import { useMutation } from 'react-query';
import { getNextWorkflowStagesTypes } from '..';
export const useGetNextWorkflowStagesTypes = () => useMutation(getNextWorkflowStagesTypes);
